import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LangProvider } from "@/i18n";
import { ContentProvider, useContent } from "@/content";
import { tryLoadGA4, readConsent } from "@/ga4";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import BackToTop from "@/components/BackToTop";
import Home from "@/pages/Home";
import LegalPage from "@/pages/LegalPage";
import Admin from "@/pages/Admin";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-[#0A0A0C] px-6 text-center">
          <div>
            <p className="eyebrow mb-4">OBSIDIAN</p>
            <p className="font-display text-2xl font-light">Si è verificato un errore. Ricarica la pagina.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function GA4Bridge() {
  const { content } = useContent();
  useEffect(() => {
    tryLoadGA4(content);
    const handler = () => tryLoadGA4(content);
    window.addEventListener("obsidian-consent", handler);
    return () => window.removeEventListener("obsidian-consent", handler);
  }, [content]);
  return null;
}

function SiteChrome() {
  const location = useLocation();
  const { content } = useContent();
  useEffect(() => {
    if (content && !readConsent()) {
      window.dispatchEvent(new Event("obsidian-consent"));
    }
    tryLoadGA4(content);
  }, [content, location.pathname]);

  if (location.pathname.startsWith("/admin")) {
    return (
      <Routes>
        <Route path="/admin" element={<Admin />} />
      </Routes>
    );
  }
  return (
    <div className="grain">
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/termini" element={<LegalPage kind="termini" />} />
        <Route path="/privacy" element={<LegalPage kind="privacy" />} />
        <Route path="/cookie" element={<LegalPage kind="cookies" />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <BackToTop />
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <LangProvider>
        <ContentProvider>
          <BrowserRouter>
            <ScrollManager />
            <GA4Bridge />
            <SiteChrome />
            <CookieBanner />
          </BrowserRouter>
        </ContentProvider>
      </LangProvider>
    </ErrorBoundary>
  );
}
